module.exports = __webpack_public_path__ + "img/sjdt-ffdcgyt.ed302fd0.png";